/* eslint-disable */

import '../vendor/chosen';

/* globals Sys:true */
(function () {
  'use strict';

  // require("vendor/chosen");

  //select menu
  if (window.innerWidth > 767) {
    $('select').addClass('chzn-select');
    /* the view port is at least 767 pixels wide */
    $('.chzn-select').chosen();
    $('.chzn-select-deselect').chosen({
      /* jshint camelcase:false */
      allow_single_deselect: true,
      /* jshint camelcase:true */
    });

    $('.chzn-single').each(function () {
      if ($(this).find('span').text() == '(Please select)') {
        $(this).addClass('chzn-default');
      }
    });
  }

  // reload chosen on partial postback
  var prm = Sys.WebForms.PageRequestManager.getInstance();
  if (prm !== null) {
    /* jshint camelcase:false */
    prm.add_endRequest(function (sender, e) {
      /* jshint camelcase:true */
      if (sender._postBackSettings.panelsToUpdate !== null) {
        if (window.innerWidth <= 767) {
          $('select').find('.text-muted').attr('disabled', true);
        }

        if (window.innerWidth > 767) {
          $('select').addClass('chzn-select');
          /* the view port is at least 767 pixels wide */
          $('.chzn-select').chosen();
          $('.chzn-select-deselect').chosen({
            /* jshint camelcase:false */
            allow_single_deselect: true,
            /* jshint camelcase:true */
          });
        }

        $('.chzn-single').each(function () {
          console.log($(this).find('span').text());
          if ($(this).find('span').text() == '(Please select)') {
            $(this).addClass('chzn-default');
          }
        });
      }
    });
  }
})();
